// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions"> <ex-mono-occurrence-ecran-bas> <ex-card-saisie formulaire="vm.formulaireImp"></ex-card-saisie> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;